import { BrowserRouter as Router } from "react-router-dom";
import "./assets/css/style.css";
import RouteIndex from "./components/RouteIndex";
import "./App.css";

function App() {
  return (
    <div className="App">
      <Router>
        <RouteIndex />
      </Router>
    </div>
  );
}

export default App;
